import React from 'react';
import classNames from 'classnames';
import { Icon } from '../icons/Icon';
import { IconNames } from '../icons/Icons';
import styles from './Link.module.scss';

export const Link = ({ children, icon, style, className, position = 'left', onClick }: Props) => {

    const classes = classNames(styles.default, className, {
        [styles[style!]]: style
    });

    return icon ? (
        <div className={classes} onClick={onClick}>
            {position === 'left' && <Icon type={icon} className={styles.icon} />}
            {children}
            {position === 'right' && <Icon type={icon} className={styles.icon} />}
        </div>
    ) : (
        <div className={classes} onClick={onClick}>
            {children}
        </div>
    );
};

type Props = {
    icon?: IconNames;
    position?: 'left' | 'right';
    style?: 'danger' | 'success' | 'warning';
    onClick: () => void;
    className?: string;
    children?: string;
};